/**
 * @generated SignedSource<<206bf7af8c425b058241173b3c3cf5ab>>
 * @relayHash 84e0a7d195cc73930afb4bb61a11b442
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 26de4c70f96cd11db74eeabfc49857db789bc16577caa734831f8a9dbc38b6f2

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PerformanceOverviewMainQuery$variables = {
  cloudId: string;
  projectLevelReportingEnabled: boolean;
  schemaMigrationEnabled: boolean;
};
export type PerformanceOverviewMainQuery$data = {
  readonly jira: {
    readonly resourceUsageMetrics?: {
      readonly " $fragmentSpreads": FragmentRefs<"OverviewPage">;
    };
    readonly resourceUsageMetricsV2?: {
      readonly " $fragmentSpreads": FragmentRefs<"OverviewPage843BadPattern">;
    };
  };
};
export type PerformanceOverviewMainQuery = {
  response: PerformanceOverviewMainQuery$data;
  variables: PerformanceOverviewMainQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectLevelReportingEnabled"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "schemaMigrationEnabled"
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "projectLevelReportingEnabled",
    "variableName": "projectLevelReportingEnabled"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "key"
},
v6 = {
  "kind": "ScalarField",
  "name": "currentValue"
},
v7 = {
  "kind": "ScalarField",
  "name": "warningValue"
},
v8 = {
  "kind": "ScalarField",
  "name": "thresholdValue"
},
v9 = {
  "kind": "ScalarField",
  "name": "cleanupValue"
},
v10 = {
  "kind": "ScalarField",
  "name": "id"
},
v11 = {
  "kind": "ScalarField",
  "name": "projectsOverLimit"
},
v12 = {
  "kind": "ScalarField",
  "name": "projectsReachingLimit"
},
v13 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v14 = [
  (v11/*: any*/),
  (v12/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "PerformanceOverviewMainQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "condition": "schemaMigrationEnabled",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "args": (v3/*: any*/),
                    "concreteType": "JiraResourceUsageMetricConnection",
                    "kind": "LinkedField",
                    "name": "resourceUsageMetrics",
                    "plural": false,
                    "selections": [
                      {
                        "args": (v4/*: any*/),
                        "kind": "FragmentSpread",
                        "name": "OverviewPage"
                      }
                    ]
                  },
                  "action": "THROW",
                  "path": "jira.resourceUsageMetrics"
                }
              ]
            },
            {
              "condition": "schemaMigrationEnabled",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "args": (v3/*: any*/),
                    "concreteType": "JiraResourceUsageMetricConnectionV2",
                    "kind": "LinkedField",
                    "name": "resourceUsageMetricsV2",
                    "plural": false,
                    "selections": [
                      {
                        "args": (v4/*: any*/),
                        "kind": "FragmentSpread",
                        "name": "OverviewPage843BadPattern"
                      }
                    ]
                  },
                  "action": "THROW",
                  "path": "jira.resourceUsageMetricsV2"
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "PerformanceOverviewMainQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "schemaMigrationEnabled",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "args": (v3/*: any*/),
                "concreteType": "JiraResourceUsageMetricConnection",
                "kind": "LinkedField",
                "name": "resourceUsageMetrics",
                "plural": false,
                "selections": [
                  {
                    "condition": "projectLevelReportingEnabled",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "concreteType": "JiraResourceUsageMetric",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "projectLevelReportingEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "concreteType": "JiraResourceUsageMetric",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v10/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "schemaMigrationEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v3/*: any*/),
                "concreteType": "JiraResourceUsageMetricConnectionV2",
                "kind": "LinkedField",
                "name": "resourceUsageMetricsV2",
                "plural": false,
                "selections": [
                  {
                    "condition": "projectLevelReportingEnabled",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v13/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "projectLevelReportingEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v13/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v14/*: any*/),
                            "type": "JiraWorkTypeUsageMetric"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v14/*: any*/),
                            "type": "JiraCustomFieldUsageMetric"
                          },
                          (v10/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "26de4c70f96cd11db74eeabfc49857db789bc16577caa734831f8a9dbc38b6f2",
    "metadata": {},
    "name": "PerformanceOverviewMainQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "4854cf1c4446dc0d62ce69d578fa8abf";

export default node;
